import { Resource } from '__types__';
import { get } from 'lodash';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getContact } from 'store/v1/contacts/contacts.actions';
import { useTranslation } from 'react-i18next';

interface GenericSearchFilterItemProps {
  label: string;
  filter: any;
  filterType: string;
  handleRemoveFilter: (params: object) => void;
  params: any;
}

const GenericSearchFilterItem: React.FC<GenericSearchFilterItemProps> = ({
  filter,
  filterType,
  handleRemoveFilter,
  params
}) => {
  const dispatch = useDispatch();
  const contacts = useSelector((state: any) => state.contacts);
  const [contact, setContact] = useState<Resource | null>(null);

  const { t } = useTranslation('shortlists');

  useEffect(() => {
    if (filterType === 'contact_id' && !get(contacts, ['data', filter.eq])) {
      dispatch(getContact(filter.eq));
    }
  }, [filterType]);

  useEffect(() => {
    if (
      filterType === 'contact_id' &&
      get(contacts, ['data', filter.eq]) &&
      (!contact || contact.id !== filter.eq)
    ) {
      // set contact if not set or if contact id has changed
      setContact(get(contacts, ['data', filter.eq]));
    }
  }, [contacts]);

  const renderLabel = () => {
    switch (filterType) {
      case 'user_id':
        return t('GenericSearchFilterItem.filters.belongsToMe');
      case 'created_at':
        // return `Created after ${filter.gte}`;
        return t('GenericSearchFilterItem.filters.createdAt', {
          date: filter.gte
        });
      case 'published':
        return t(
          filter.eq
            ? 'GenericSearchFilterItem.filters.publishedOnly'
            : 'GenericSearchFilterItem.filters.draftOnly'
        );
      case 'archived':
        return filter.eq ? t('GenericSearchFilterItem.filters.archived') : '';
      case 'contact_id':
        return filter.eq
          ? t('GenericSearchFilterItem.filters.contactId', {
              contact: contact?.full_name
            })
          : '';
      case 'production_dates':
      case 'events':
        return t('GenericSearchFilterItem.filters.between', {
          startDate: moment(filter.gte).format('Do MMMM'),
          endDate: moment(filter.lte).format('Do MMMM')
        });
      case 'tags':
        function truncate(tags: string[], n: number) {
          if (tags.length > n) {
            const visibleTags = tags.slice(0, n).join(', ');
            return (
              visibleTags +
              t('GenericSearchFilterItem.filters.tags.and') +
              (tags.length - n) +
              t('GenericSearchFilterItem.filters.tags.more')
            );
          }
          return tags.join(', ');
        }

        if (filter.any) {
          return t('GenericSearchFilterItem.filters.tags.any', {
            tag: truncate(filter.any, 3)
          });
        }
        if (filter.match) {
          return t('GenericSearchFilterItem.filters.tags.match', {
            tags: truncate(filter.match, 3)
          });
        }
        return '??';
      default:
        return null;
    }
  };

  return (
    <span key={filter.id} className="PageSearch-activeFilters-item">
      {renderLabel()}{' '}
      <span
        className="PageSearch-activeFilters-item-remove"
        onClick={() => {
          handleRemoveFilter(params);
        }}
      >
        <img src="/images/icon_close_white.svg" alt="" />
      </span>
    </span>
  );
};

export default GenericSearchFilterItem;
